import { useEffect } from "react";

const useScrollReveal = (selector, animationClass) => {
  useEffect(() => {
    const elements = document.querySelectorAll(selector);

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(animationClass);
            observer.unobserve(entry.target); // Stop observing after the first reveal
          }
        });
      },
      {
        threshold: 0.2, // Adjust this value for when the animation should trigger
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, [selector, animationClass]);
};

export default useScrollReveal;
